<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>系统设置</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								size="small"
								placeholder="输入党员姓名搜索"
								prefix-icon="el-icon-search"
								style="width: 200px;margin-right: 20px;"
								v-model="getdata.name"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select 
								size="small"
								style="width: 120px;margin-right: 20px;"
								v-model="getdata.u_zhiwu" clearable filterable placeholder="请选择职务"
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									label="书记"
									value="1">
								</el-option>
								<el-option
									label="副书记"
									value="2">
								</el-option>
								<el-option
									label="委员"
									value="3">
								</el-option>
								<el-option
									label="党员"
									value="4">
								</el-option>
								<el-option
									label="发展党员"
									value="5">
								</el-option>
							</el-select>
						</div>
					</div>
						<myTables 
						:tableData="tableData"
						delkey=""
						:tableHeader="tableHeader"
						:loading="true" 
						:indexs="false"
						:selection="false"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { dwgl,xtsz } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	export default{
		data(){
			return{
				getdata:{
					id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					status: "",
					name: "",
					u_zhiwu:"",
					sex: "",
					page:1,
					sign:2
				},
				tableHeader: [     // 表头
					{prop: 'u_phone', label: '登陆账号'},
					{prop: 'u_name', label: '姓名',width:"90"},
					{prop: 'cy_zz', label: '所属组织',width:""},
					{prop: 'u_zhiwu', label: '身份',width:"100",formatData:(val) => {
						return this.$changeZhiwu(val)
					}},
					{prop: 'normal', label: '状态',width:"80",formatData:(val) => {
						if(val == 1){
							return '正常'
						}else if(val == 2){
							return '已禁用'
						}else{
							return '账号异常'
						}
					}},
					// 操作栏
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '150',
						oper: [
							{name: "禁用", style: {color:'#bb0000'}, clickFun: this.forbid},
							{name: '重置密码', style: {color:'#bb0000'}, clickFun: this.reset},
						]
					}
				],
				tableData:[],
				totalPage:0
			}
		},
		components:{tree,Page,myTables},
		methods:{
			// 数据
			dataList(){
				var that = this;
				that.tableData = [];
				dwgl.memberAdmin(that.getdata).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			// 树形结构筛选
			treeSelect(data){
				var that = this;
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 分页筛选
			changedata(curret){
				var that = this;
				that.getdata.page = curret;
				that.dataList();
			},
			// 禁止账号
			forbid(data){
				var that = this;
				xtsz.updateMemberStatu({
					normal: data.normal == 1?data.normal = 2:1,
					id:data.id
				}).then(res => {
					that.dataList();
				})
			},
			// 重置账号
			reset(data){
				var that = this;
				xtsz.resetUserPwd({
					id:data.id
				}).then(res => {
					if(res.code == 200){
						Message({
							type:"success",
							message:res.msg
						})
						that.dataList();
					}else{
						Message({
							type:"error",
							message:res.msg
						})
					}
				})
			}
		},
		mounted() {
			var that = this;
			that.dataList();
		},
		created() {
			var that = this;
			that.$emit('selectTop',7)
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

